import { render, staticRenderFns } from "./CategoriesManager.vue?vue&type=template&id=bb4e366e&scoped=true&"
import script from "./CategoriesManager.vue?vue&type=script&lang=js&"
export * from "./CategoriesManager.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesManager.vue?vue&type=style&index=0&id=bb4e366e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4e366e",
  null
  
)

export default component.exports